export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M32 4 Q34 28 60 32 Q34 34 32 60 Q30 34 4 32 Q30 30 32 4 Z" />
      <circle cx="32" cy="32" r="2.5" fill="var(--bg, #fff)" />
    </svg>
  );
}
